export default __webpack_public_path__ + "static/media/amDotNetv1-4.30ff20d9.jpg";